var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecurityIcon = function SvgSecurityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 8.5a1.25 1.25 0 0 0-2.5 0v1.25h2.5V8.5ZM14.5 11.25h-5a.751.751 0 0 0-.75.75v3a.751.751 0 0 0 .75.75h5a.751.751 0 0 0 .75-.75v-3a.751.751 0 0 0-.75-.75Z",
    fill: "#12B76A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.182 4.183c-1.34-.143-2.66-.441-3.932-.889a17.332 17.332 0 0 1-3.335-1.597 1.752 1.752 0 0 0-1.83 0A17.349 17.349 0 0 1 7.75 3.294c-1.271.448-2.59.746-3.93.889a1.746 1.746 0 0 0-1.57 1.739v5.195a10.754 10.754 0 0 0 5.53 9.397l3.37 1.873a1.734 1.734 0 0 0 1.7 0l3.37-1.873a10.755 10.755 0 0 0 5.53-9.397V5.922a1.746 1.746 0 0 0-1.568-1.74ZM16.75 15a2.253 2.253 0 0 1-2.25 2.25h-5a2.253 2.253 0 0 1-2.25-2.25v-3a2.246 2.246 0 0 1 2-2.225V8.501a2.75 2.75 0 1 1 5.5 0v1.275a2.246 2.246 0 0 1 2 2.225v3Z",
    fill: "#12B76A"
  })));
};
export default SvgSecurityIcon;